var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import $ from 'jquery';
import { containsElementWithId, createDemoNote, createDemoVideo, createLiveFeedIframe, getConfiguration, refreshIframe } from './common';
/**
 * Enables the "ISSAC secondary" page functionality.
 */
const enableIssacSecondaryFunctionality = () => __awaiter(void 0, void 0, void 0, function* () {
    if ($('#issac-secondary').length === 0) {
        return;
    }
    yield _getConfiguration();
    // refresh the live feed every hour
    setInterval(() => {
        refreshIframe('iss-live-feed');
    }, (1000 * 60 * 60));
    // check for demo mode every minute
    setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
        yield _getConfiguration();
    }), (1000 * 60));
    /**
     * Gets the current page configuration.
     */
    function _getConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const $feedContainer = $('#feed-container');
                const config = yield getConfiguration('issac-secondary.json');
                // switch to demo mode
                if (config.demoMode && config.nasaFeedDemoVideoSrc && !containsElementWithId('iss-feed-demo')) {
                    $feedContainer.empty().css('margin', '');
                    $feedContainer.append(createDemoVideo(config.nasaFeedDemoVideoSrc)).append(createDemoNote());
                }
                // switch to live mode
                else if (!config.demoMode && !containsElementWithId('iss-live-feed')) {
                    $feedContainer.empty().css('margin', '-71px 450px 0 -450px');
                    const div = $('<div></div>').attr('id', 'iss-live-feed-wrapper');
                    div.append(createLiveFeedIframe(config.nasaFeedVideoSrc));
                    $feedContainer.append(div);
                }
                // check if live feed URL has changed
                else if (!config.demoMode) {
                    const $iframe = $('#iss-live-feed');
                    if (config.nasaFeedVideoSrc !== $iframe.attr('src')) {
                        $iframe.attr('src', config.nasaFeedVideoSrc);
                    }
                }
            }
            catch (e) {
                console.log(e);
            }
        });
    }
});
export default enableIssacSecondaryFunctionality;
